<template>
  <div class="table-page-wrapper">
    <div v-show="searchStatus" class="search-wrapper">
      <el-input placeholder="商品关键字" v-model="tableParams.title" clearable></el-input>
      <el-input placeholder="最低分佣（分）" v-model="tableParams.cosFeeMin" clearable></el-input>
      <el-input placeholder="最高分佣（分）" v-model="tableParams.cosFeeMax" clearable></el-input>
      <el-input placeholder="最低分佣：如1.1%=110" v-model="tableParams.cosRatioMin" clearable></el-input>
      <el-input placeholder="最高分佣：如1.1%=110" v-model="tableParams.cosRatioMax" clearable></el-input>
      <div class="search-row">
        <el-input placeholder="商品最低价格（分）" v-model="tableParams.priceMin" clearable></el-input>
        <el-input placeholder="商品最高价格（分）" v-model="tableParams.priceMax" clearable></el-input>
        <el-input placeholder="历史销量最小值" v-model="tableParams.sellNumMin" clearable></el-input>
        <el-input placeholder="历史销量最大值" v-model="tableParams.sellNumMax" clearable></el-input>
      </div>
      <el-button @click="toQuery" type="primary" >搜索</el-button>
    </div>

    <div class="table-wrapper">
      <el-table
        v-loading="tableLoading"
        :data="tableData"
        height="80vh"
        :header-cell-style="{ background: '#fafafa' }"
        ref="report"
        row-key="id"
        lazy
        size="small"
        class="js-table"
        style="width: 100%"
      >
        <el-table-column
          v-for="(v, i) in checkColumns"
          :prop="v.field"
          :label="v.title"
          :width="v.width"
          sortable
          :min-width="v.minWidth"
          :key="i"
          align="center">
          <template v-slot="scope">
            <template v-if="v.field === 'cover'">
              <el-popover
                placement="top-start"
                width="200"
                trigger="hover"
                ref="popover"
              >
                <template #reference>
                  <el-image
                    :src="scope.row[v.field]"
                    error="-"
                    width="100"
                  >
                    <template #error>
                      <div class="image-slot">
                        <span>-</span>
                      </div>
                    </template>
                  </el-image>
                </template>
                <img
                  :src="scope.row[v.field]"
                  style="height: 250px"
                 alt=""/>
              </el-popover>
            </template>
            <template v-else-if="v.field === 'detailUrl'">
              <el-tooltip effect="dark" content="点击复制" placement="top">
                <span
                  class="tab-editor"
                  @click="handleCopy"
                >{{ scope.row[v.field] }}</span>
              </el-tooltip>
            </template>
            <template v-else-if="v.field === 'inStock' || v.field === 'isKolProduct'">
              <span>{{ scope.row[v.field]  ? "有" : "无" }} </span>
            </template>
            <template v-else-if="v.field === 'checked'">
              <el-switch v-model="scope.row.checked" active-color="#13ce66" :active-value="1" :inactive-value="0"
                         @change="updateCheckedProduct(scope.row)" />
            </template>
            <span v-else>{{ scope.row[v.field] }}</span>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :total="pagination.total"
        :pager-count="6"
        :current-page="page"
        :page-size="pageSize"
        :page-sizes="[10, 20]"
        background
        layout="total,sizes,prev,pager,next"
        style="margin-top: 40px;" />
    </div>
  </div>
</template>

<script>
import initTableMixin from '@/mixins/initTable'
import { updateCheckedProduct } from '@/api/manage/cps/commodity'

export default {
  name: 'commodity',
  components: {
  },
  mixins: [initTableMixin],
  data () {
    return {
      page: 1,
      pageSize: 20,
      checkColumns: [
        { field: 'productId', title: '商品id' },
        { field: 'title', title: '商品名称' },
        { field: 'price', title: '商品价格（分）' },
        { field: 'inStock', title: '有无库存' },
        { field: 'cover', title: '商品主图' },
        { field: 'detailUrl', title: '商品链接' },
        { field: 'sales', title: '商品历史销量' },
        { field: 'cosRatio', title: '分佣比例（百分比）' },
        { field: 'cosFee', title: '佣金金额（分）' },
        { field: 'isKolProduct', title: '是否有达人特殊佣金' },
        { field: 'checked', title: '是否被选中' }
      ]
    }
  },
  created() {
    this.init()
  },
  methods: {
    beforeInit () {
      this.tableUrl = '/product/search'
      this.tableParams.page = this.page
      this.tableParams.pageSize = this.pageSize
      return true
    },
    afterInit (res) {
      this.tableData = res.data.products
    },
    sizeChange (e) {
      this.pageSize = e
      this.tableParams.pageSize = e
      this.init()
    },
    currentChange (e) {
      this.page = e
      this.tableParams.page = e
      this.init()
    },
    toQuery () {
      this.init()
    },
    changeCpsApp (item) {
      this.tableParams.appId = item
    },
    updateCheckedProduct (item) {
      updateCheckedProduct({ appId: this.tableParams.appId, checked: item.checked, productId: item.productId })
    },
    // 点击复制
    handleCopy (e) {
      const text = e.target.innerText
      const input = document.createElement('input')

      input.setAttribute('id', 'copyInput')
      input.setAttribute('value', text)
      document.getElementsByTagName('body')[0].appendChild(input)
      document.getElementById('copyInput').select()
      if (document.execCommand('copy')) {
        this.$message({
          type: 'success',
          message: '复制成功'
        })
      } else {
        this.$message({
          type: 'error',
          message: '浏览器不支持复制功能'
        })
      }
      document.getElementById('copyInput').remove()
    }
  }
}
</script>

<style scoped lang="scss">
.search-wrapper {
  padding: 15px 15px 5px;
  margin-bottom: 10px;
  background: #ffffff;

  & > * {
    margin-right: 30px;
    margin-bottom: 10px;

    &:last-child {
      margin-right: 0;
    }
  }

  & > .el-select,
  & > .el-input {
    width: 220px;
  }
}

.search-row {
  & > .el-select,
  & > .el-input {
    margin-right: 30px;
    width: 220px;
  }
}

.table-wrapper {
  padding: 15px;
  background: #ffffff;

  .table__operation {
    padding-bottom: 10px;
  }
}

.el-pagination {
  text-align: right;
}

::v-deep.el-table__placeholder {
  display: none;
}

::v-deep.el-table__expand-icon {
  width: auto !important;
}

</style>
